// Utility functions for storing login token with 6 hour expiration

export function setToken(token) {
    const now = new Date();
    const item = {
        token: token,
        expiry: now.getTime() + 6 * 60 * 60 * 1000 // 6 hours in ms
    };
    localStorage.setItem('authToken', JSON.stringify(item));
}

export function getToken() {
    const itemStr = localStorage.getItem('authToken');
    if (!itemStr) {
        return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (now.getTime() > item.expiry) {
        localStorage.removeItem('authToken');
        return null;
    }
    return item.token;
}

export function removeToken() {
    localStorage.removeItem('authToken');
}

export function getEmailFromToken() {
    const token = getToken();
    if (!token) return null;
    try {
        const payload = token.split('.')[1];
        const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
        return decoded.email || decoded.sub || null;
    } catch (e) {
        return null;
    }


}

export function getUserIdFromToken() {
    const token =  getToken();
    if (!token) return null;
    try {
        // JWT format: header.payload.signature
        const payload = token.split('.')[1];
        if (!payload) return null;
        const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
        // Adjust the key below if your user id is stored under a different key
        return decoded.userId || decoded.sub || null;
    } catch (err) {
        return null;
    }
}
